import styles from './HomeCliente.module.css'
import FooterOpcoes from '../components/FooterOpcoes';
import { useNavigate } from "react-router-dom";
import { FaUtensils, FaMapMarkerAlt, FaSearch } from 'react-icons/fa';
import { EstabelecimentosContext } from "../../../shared/contexts/EstabelecimentosContext";
import { useContext, useEffect } from 'react';
import { ProdutosContext } from '../../../shared/contexts/ProdutosContext';
import { CategoriasContext } from "../../../shared/contexts/CategoriasContext";
import CarrinhoIcon from '../components/CarrinhoIcon';
import CardEstabelecimento from '../components/CardEstabelecimento';




function HomeCliente() {
    const navigate = useNavigate();

    const {estabelecimentos, fetchEstabelecimentos} = useContext(EstabelecimentosContext)
    const {produtos} = useContext(ProdutosContext)
    const { categorias } = useContext(CategoriasContext);

    // Recarregar estabelecimentos ao montar (garante que id_universidade do login já está no localStorage)
    useEffect(() => {
        fetchEstabelecimentos();
    }, []);

    // Garante que sejam arrays
    const produtosArray = Array.isArray(produtos) ? produtos : [];
    const estabelecimentosArray = Array.isArray(estabelecimentos) ? estabelecimentos : [];
    const categoriasArray = Array.isArray(categorias) ? categorias : [];

    // Contexto do último estabelecimento visitado (ex: via QR code — ver ItensEstabelecimento).
    // '' = restaurante avulso (sem universidade): mostra só ele, não a lista toda.
    const contextoUniversidade = localStorage.getItem("estabelecimento_contexto_universidade");
    const contextoEstabelecimentoId = localStorage.getItem("estabelecimento_contexto_id");
    const isRestauranteContext = contextoUniversidade === '' && !!contextoEstabelecimentoId;

    const estabelecimentosExibidos = isRestauranteContext
        ? estabelecimentosArray.filter(
            (e) => String(e.id_estabelecimento) === String(contextoEstabelecimentoId)
          )
        : estabelecimentosArray;

    const nomeUniversidade = isRestauranteContext
        ? (estabelecimentosExibidos[0]?.nomeEstabelecimento || "Seu estabelecimento")
        : (localStorage.getItem("nomeUniversidade") || "USJT - São Paulo");

    const produtosPromocao = produtosArray.filter(
    produto => produto.promocao === "sim" && produto.disponivel?.toLowerCase() === "sim"
  );


  return (
    <div className={styles.container}>
      {/* Header Laranja */}
      <header className={styles.header}>
        <div className={styles.headerContent}>
          <div className={styles.locationInfo}>
            <FaMapMarkerAlt className={styles.locationIcon} />
            <span className={styles.locationText}>{nomeUniversidade}</span>
          </div>
          {/* Ícone do Carrinho no Header */}
          <CarrinhoIcon />
        </div>
      </header>

      {/* Barra de Busca */}
      <div className={styles.searchContainer}>
        <div className={styles.searchWrapper}>
          <FaSearch className={styles.searchIcon} />
          <input
            type="text"
            placeholder="Buscar restaurantes ou pratos..."
            className={styles.searchInput}
          />
        </div>
      </div>

      {/* Seção de Categorias */}
      <div className={styles.categoriasSection}>
        <h2 className={styles.sectionTitle}>Categorias</h2>
        <div className={styles.categoriasScroll}>
          {/* Botão "Todos" sempre primeiro */}
          <div className={styles.categoriaItem} onClick={() => navigate('/vermais', { state: { section: 'lojas' } })}>
            <div className={styles.categoriaIconContainer} style={{backgroundColor: '#d33333'}}>
              <FaUtensils className={styles.categoriaIcon} />
            </div>
            <span className={styles.categoriaLabel}>Todos</span>
          </div>

          {categoriasArray.map((categoria) => (
            <div
              className={styles.categoriaItem}
              key={categoria.id_categoria}
              onClick={() => navigate(`/categoria/${categoria.id_categoria}`)}
            >
              <div className={styles.categoriaIconContainer}>
                <img src={categoria.icone} alt={categoria.nome_categoria} />
              </div>
              <span className={styles.categoriaLabel}>{categoria.nome_categoria}</span>
            </div>
          ))}
        </div>
      </div>

      {/* Seção de Estabelecimentos */}
      <div className={styles.estabelecimentosSection}>
        <h2 className={styles.sectionTitle}>
          {isRestauranteContext ? "Estabelecimento" : "Estabelecimentos"}
        </h2>

        {estabelecimentosExibidos.map((estabelecimento) => (
          <CardEstabelecimento
            key={estabelecimento.id_estabelecimento}
            estabelecimento={estabelecimento}
          />
        ))}
      </div>

      {/* Seção de Promoções */}
      <div className={styles.promocoesSection}>
        <div className={styles.sectionHeader}>
          <h2 className={styles.sectionTitle}>Promoções</h2>
          <span className={styles.verTodas} onClick={() => navigate('/vermais', { state: { section: 'promocoes' } })}>
            Ver todas
          </span>
        </div>
<div className={styles.promocoesScroll}>
  {produtosPromocao.length > 0 ? (
    produtosPromocao.slice(0, 5).map((produto, index) => {
      const cores = [
        'linear-gradient(135deg, #e84444 0%, #d33333 100%)',
        'linear-gradient(135deg, #d33333 0%, #bb2222 100%)',
        'linear-gradient(135deg, #c0392b 0%, #96281b 100%)',
        'linear-gradient(135deg, #e84444 0%, #c0392b 100%)',
        'linear-gradient(135deg, #bb2222 0%, #8c1010 100%)'
      ];

      return (
        <div
          className={styles.promocaoCard}
          key={produto.id_item}
          style={{ background: cores[index % cores.length] }}
          onClick={() =>
            navigate(`/estabelecimento/${produto.id_estabelecimento}`)
          }
        >
          <div className={styles.promocaoInfo}>
            <div className={styles.promocaoBadge}>
              {produto.desconto ? `${Number(produto.desconto)}% OFF` : 'PROMO'}
            </div>
            <h3 className={styles.promocaoNome}>
              {produto.nome_item}
            </h3>
          </div>

            {produto.imagem && (
              <img
                src={produto.imagem}
                alt={produto.nome_item}
                className={styles.promocaoImg}
              />
            )}
          </div>
        );
      })
    ) : (
      <p className={styles.pPromocao}>
        Opa! No momento não temos promoções rolando.</p>
    )}
  </div>

      </div>

      {/* Footer */}
      <FooterOpcoes typeView="cliente"/>
    </div>
  );
}

export default HomeCliente;
